export const phoneNumberRegExp = /^\+7 \(\d\d\d\) \d\d\d - \d\d\d\d$/;
